"use client";

import Image from "next/image";
import "./ServiceHeroSection.scss";
import BannerImage from "@/assets/images/products/serviceconnect/serviceconnect-dashboard.png";

const ServiceHeroSection = () => {
  return (
    <section className="service-hero-section">
      <div className="container">
        <div className="text-content">
          <h1>
            Simplify Service Operations <br /> with Service Connect
          </h1>

          <p>
            Seamless service request management, real-time tracking, and
            customer <br /> satisfaction—all in one platform.
          </p>
        </div>

        <div className="banner-wrapper">
          <Image
            src={BannerImage}
            alt="Service Connect Dashboard"
            className="banner-image"
            data-aos="fade-up"
            width={900}
            height={600}
          />
        </div>
      </div>
    </section>
  );
};

export default ServiceHeroSection;
